// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.match-history-container {
    background: white;
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
}

.match-history-container h3 {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 1.1rem;
    color: #334155;
    border-bottom: 1px solid #f1f5f9;
    padding-bottom: 10px;
}

.history-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.history-card {
    display: flex;
    align-items: center;
    background: #F8FAFC;
    border: 1px solid #E2E8F0;
    border-radius: 12px;
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.history-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    border-color: #CBD5E1;
}

.match-date {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-right: 15px;
    border-right: 1px solid #E2E8F0;
    min-width: 50px;
}

.match-date .day {
    font-size: 1.2rem;
    font-weight: 800;
    color: #475569;
    line-height: 1;
}

.match-date .month {
    font-size: 0.65rem;
    color: #94A3B8;
    font-weight: 600;
}

.match-info {
    flex: 1;
    padding-left: 15px;
    display: flex;
    flex-direction: column;
}

.match-info .opponent {
    font-weight: 600;
    color: #1e293b;
    font-size: 0.95rem;
}

.match-info .location {
    font-size: 0.75rem;
    color: #64748B;
}

.match-score {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
}

.score-numbers {
    font-family: monospace; /* Para números alineados */
    font-size: 1.1rem;
    font-weight: 700;
    color: #334155;
}

.badge {
    font-size: 0.7rem;
    padding: 2px 8px;
    border-radius: 99px;
    font-weight: 600;
    text-transform: uppercase;
}

.badge.win { background: #DCFCE7; color: #166534; }
.badge.loss { background: #FEE2E2; color: #991B1B; }
.badge.draw { background: #F3F4F6; color: #4B5563; }
.badge.pending { background: #FFF7ED; color: #C2410C; }

.empty-history {
    text-align: center;
    padding: 30px;
    color: #94A3B8;
}
/* ── Temporadas y Fases ─────────────────────────────────── */

.history-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: .75rem;
    margin-bottom: 1rem;
}

.history-header h3 {
    margin: 0;
}

.season-filter {
    display: flex;
    align-items: center;
    gap: .5rem;
    font-size: .9rem;
    color: #555;
}

.season-select {
    border: 1.5px solid #d1d5db;
    border-radius: 8px;
    padding: .35rem .75rem;
    font-size: .9rem;
    outline: none;
    cursor: pointer;
}

.season-select:focus { border-color: #f5a623; }

.phase-section {
    margin-bottom: 1.5rem;
}

.phase-title {
    font-size: 1rem;
    font-weight: 700;
    color: #1a1a2e;
    margin: 0 0 .75rem;
    display: flex;
    align-items: center;
    gap: .5rem;
    border-left: 4px solid #f5a623;
    padding-left: .75rem;
}

.phase-title.clickable {
    cursor: pointer;
    user-select: none;
    transition: opacity .15s;
}

.phase-title.clickable:hover { opacity: .75; }

.phase-chevron {
    font-size: .72rem;
    color: #94a3b8 !important;
    flex-shrink: 0;
}

.phase-flag {
    /* color viene del style inline por fase */
    flex-shrink: 0;
}

.phase-count {
    font-size: .78rem;
    font-weight: 500;
    color: #94a3b8;
    margin-left: auto;
    padding-right: .25rem;
}

/* Botón editar fase — overlay en esquina superior derecha, visible solo en hover */
.history-card-wrapper {
    position: relative;
}

.btn-edit-phase {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;

    display: flex;
    align-items: center;
    gap: .3rem;

    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    color: #94a3b8;
    cursor: pointer;
    padding: .28rem .55rem;
    font-size: .75rem;
    box-shadow: 0 1px 4px rgba(0,0,0,.08);

    opacity: 0;
    pointer-events: none;
    transition: opacity .18s, color .18s, border-color .18s;
}

.history-card-wrapper.captainable:hover .btn-edit-phase {
    opacity: 1;
    pointer-events: auto;
}

.btn-edit-phase:hover {
    color: #3b82f6;
    border-color: #3b82f6;
    background: #eff6ff;
}

/* Badge de temporada en el título */
.season-tag {
    display: inline-block;
    background: #fef3c7;
    color: #92400e;
    font-size: .72rem;
    font-weight: 700;
    padding: .15rem .55rem;
    border-radius: 99px;
    margin-left: .6rem;
    vertical-align: middle;
}

.no-phase-matches {
    text-align: center;
    color: #999;
    padding: 1.5rem 0;
    font-size: .95rem;
}

.history-card-wrapper {
    margin-bottom: .6rem;
    /* position: relative ya está declarado en el bloque del botón */
}

/* Botón asignar fase (solo capitanas) */
.btn-assign-phase {
    background: none;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    color: #6b7280;
    cursor: pointer;
    padding: .3rem .5rem;
    font-size: .85rem;
    transition: all .2s;
    margin-left: auto;
    flex-shrink: 0;
}

.btn-assign-phase:hover {
    background: #fff7ed;
    border-color: #f5a623;
    color: #f5a623;
}

/* Panel de asignación inline */
.assign-panel {
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 0 0 10px 10px;
    padding: .75rem 1rem;
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;
    align-items: center;
}

.assign-select {
    border: 1.5px solid #d1d5db;
    border-radius: 8px;
    padding: .35rem .65rem;
    font-size: .9rem;
    outline: none;
    flex: 1;
    min-width: 130px;
}

.assign-select:focus { border-color: #1a1a2e; outline: none; }

.assign-actions {
    display: flex;
    gap: .5rem;
}

.btn-save-assign {
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    color: #fff;
    border: none;
    border-radius: 7px;
    padding: .4rem .9rem;
    font-size: .85rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: .3rem;
    transition: opacity .15s;
}

.btn-save-assign:hover { opacity: .85; }

.btn-cancel-assign {
    background: none;
    border: 1px solid #d1d5db;
    border-radius: 7px;
    padding: .4rem .9rem;
    font-size: .85rem;
    cursor: pointer;
    color: #6b7280;
}

.btn-cancel-assign:hover { background: #f3f4f6; }

/* ── Phase points badge ─────────────────────────────────── */

.phase-pts-badge {
    font-size: .72rem;
    font-weight: 700;
    padding: .15rem .55rem;
    border-radius: 99px;
    margin-left: .5rem;
    white-space: nowrap;
    flex-shrink: 0;
}

/* ── Standings block ─────────────────────────────────────── */

.standings-block {
    margin-top: 14px;
    margin-bottom: 16px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px 16px;
}

.standings-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.standings-title {
    font-size: .88rem;
    font-weight: 700;
    color: #334155;
    display: flex;
    align-items: center;
    gap: .4rem;
}

.standings-title i {
    color: #94a3b8;
}

.btn-add-standing {
    background: none;
    border: 1px solid #d1d5db;
    border-radius: 7px;
    color: #6b7280;
    font-size: .78rem;
    cursor: pointer;
    padding: .3rem .65rem;
    display: flex;
    align-items: center;
    gap: .3rem;
    transition: all .18s;
}

.btn-add-standing:hover {
    background: #eff6ff;
    border-color: #3b82f6;
    color: #3b82f6;
}

.standings-table {
    width: 100%;
    border-collapse: collapse;
    font-size: .85rem;
    margin-bottom: 0;
}

.standings-table thead tr {
    border-bottom: 1px solid #e2e8f0;
}

.standings-table th {
    padding: .3rem .5rem;
    text-align: left;
    font-size: .7rem;
    font-weight: 700;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: .5px;
}

.standings-table td {
    padding: .45rem .5rem;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: middle;
}

.standings-table tr:last-child td { border-bottom: none; }

.standing-pos {
    width: 28px;
    font-weight: 700;
    color: #94a3b8;
    font-size: .8rem;
}

.standing-name {
    font-weight: 600;
    color: #1e293b;
}

.standing-pts {
    font-weight: 700;
    color: #0f172a;
    text-align: center;
    width: 40px;
}

.standing-actions {
    text-align: right;
    white-space: nowrap;
    width: 60px;
}

.btn-standing-edit,
.btn-standing-del {
    background: none;
    border: none;
    cursor: pointer;
    padding: .2rem .35rem;
    font-size: .78rem;
    border-radius: 5px;
    transition: background .15s, color .15s;
}

.btn-standing-edit { color: #94a3b8; }
.btn-standing-edit:hover { background: #eff6ff; color: #3b82f6; }

.btn-standing-del { color: #94a3b8; }
.btn-standing-del:hover { background: #fee2e2; color: #dc2626; }

/* ── Standing row — our team highlight ─────────────────── */

.standing-row--ours {
    background: #f0fdf4;
}

.standing-row--ours .standing-name {
    color: #15803d;
    font-weight: 700;
}

.standing-our-icon {
    color: #16a34a;
    font-size: .7rem;
    margin-right: .35rem;
    vertical-align: middle;
}

/* ── Inline pts edit input ──────────────────────────────── */

.standing-pts-input {
    width: 52px;
    border: 1.5px solid #3b82f6;
    border-radius: 6px;
    padding: .2rem .35rem;
    font-size: .88rem;
    font-weight: 700;
    text-align: center;
    outline: none;
}

.standing-pts-input:focus { border-color: #1e293b; }
`, "",{"version":3,"sources":["webpack://./src/components/MatchHistory.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,sBAAsB,EAAE,2BAA2B;IACnD,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,aAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;;AAEtD;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;AACA,8DAA8D;;AAE9D;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;;AAEA,uBAAuB,qBAAqB,EAAE;;AAE9C;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA,+BAA+B,YAAY,EAAE;;AAE7C;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA,mFAAmF;AACnF;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;;IAEV,aAAa;IACb,mBAAmB;IACnB,UAAU;;IAEV,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,qCAAqC;;IAErC,UAAU;IACV,oBAAoB;IACpB,uDAAuD;AAC3D;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gEAAgE;AACpE;;AAEA,wCAAwC;AACxC;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,+BAA+B;AAC/B;IACI,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAC5B,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,OAAO;IACP,gBAAgB;AACpB;;AAEA,uBAAuB,qBAAqB,EAAE,aAAa,EAAE;;AAE7D;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,6DAA6D;IAC7D,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,wBAAwB;AAC5B;;AAEA,yBAAyB,YAAY,EAAE;;AAEvC;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA,2BAA2B,mBAAmB,EAAE;;AAEhD,8DAA8D;;AAE9D;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,+DAA+D;;AAE/D;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA,oCAAoC,mBAAmB,EAAE;;AAEzD;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA,qBAAqB,cAAc,EAAE;AACrC,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE,oBAAoB,cAAc,EAAE;AACpC,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;;AAE/D,6DAA6D;;AAE7D;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA,8DAA8D;;AAE9D;IACI,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA,4BAA4B,qBAAqB,EAAE","sourcesContent":[".match-history-container {\n    background: white;\n    padding: 20px;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n    margin-top: 20px;\n}\n\n.match-history-container h3 {\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 1.1rem;\n    color: #334155;\n    border-bottom: 1px solid #f1f5f9;\n    padding-bottom: 10px;\n}\n\n.history-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.history-card {\n    display: flex;\n    align-items: center;\n    background: #F8FAFC;\n    border: 1px solid #E2E8F0;\n    border-radius: 12px;\n    padding: 12px 16px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.history-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0,0,0,0.05);\n    border-color: #CBD5E1;\n}\n\n.match-date {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding-right: 15px;\n    border-right: 1px solid #E2E8F0;\n    min-width: 50px;\n}\n\n.match-date .day {\n    font-size: 1.2rem;\n    font-weight: 800;\n    color: #475569;\n    line-height: 1;\n}\n\n.match-date .month {\n    font-size: 0.65rem;\n    color: #94A3B8;\n    font-weight: 600;\n}\n\n.match-info {\n    flex: 1;\n    padding-left: 15px;\n    display: flex;\n    flex-direction: column;\n}\n\n.match-info .opponent {\n    font-weight: 600;\n    color: #1e293b;\n    font-size: 0.95rem;\n}\n\n.match-info .location {\n    font-size: 0.75rem;\n    color: #64748B;\n}\n\n.match-score {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 4px;\n}\n\n.score-numbers {\n    font-family: monospace; /* Para números alineados */\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #334155;\n}\n\n.badge {\n    font-size: 0.7rem;\n    padding: 2px 8px;\n    border-radius: 99px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.badge.win { background: #DCFCE7; color: #166534; }\n.badge.loss { background: #FEE2E2; color: #991B1B; }\n.badge.draw { background: #F3F4F6; color: #4B5563; }\n.badge.pending { background: #FFF7ED; color: #C2410C; }\n\n.empty-history {\n    text-align: center;\n    padding: 30px;\n    color: #94A3B8;\n}\n/* ── Temporadas y Fases ─────────────────────────────────── */\n\n.history-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: .75rem;\n    margin-bottom: 1rem;\n}\n\n.history-header h3 {\n    margin: 0;\n}\n\n.season-filter {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n    font-size: .9rem;\n    color: #555;\n}\n\n.season-select {\n    border: 1.5px solid #d1d5db;\n    border-radius: 8px;\n    padding: .35rem .75rem;\n    font-size: .9rem;\n    outline: none;\n    cursor: pointer;\n}\n\n.season-select:focus { border-color: #f5a623; }\n\n.phase-section {\n    margin-bottom: 1.5rem;\n}\n\n.phase-title {\n    font-size: 1rem;\n    font-weight: 700;\n    color: #1a1a2e;\n    margin: 0 0 .75rem;\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n    border-left: 4px solid #f5a623;\n    padding-left: .75rem;\n}\n\n.phase-title.clickable {\n    cursor: pointer;\n    user-select: none;\n    transition: opacity .15s;\n}\n\n.phase-title.clickable:hover { opacity: .75; }\n\n.phase-chevron {\n    font-size: .72rem;\n    color: #94a3b8 !important;\n    flex-shrink: 0;\n}\n\n.phase-flag {\n    /* color viene del style inline por fase */\n    flex-shrink: 0;\n}\n\n.phase-count {\n    font-size: .78rem;\n    font-weight: 500;\n    color: #94a3b8;\n    margin-left: auto;\n    padding-right: .25rem;\n}\n\n/* Botón editar fase — overlay en esquina superior derecha, visible solo en hover */\n.history-card-wrapper {\n    position: relative;\n}\n\n.btn-edit-phase {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    z-index: 2;\n\n    display: flex;\n    align-items: center;\n    gap: .3rem;\n\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    color: #94a3b8;\n    cursor: pointer;\n    padding: .28rem .55rem;\n    font-size: .75rem;\n    box-shadow: 0 1px 4px rgba(0,0,0,.08);\n\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity .18s, color .18s, border-color .18s;\n}\n\n.history-card-wrapper.captainable:hover .btn-edit-phase {\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.btn-edit-phase:hover {\n    color: #3b82f6;\n    border-color: #3b82f6;\n    background: #eff6ff;\n}\n\n/* Badge de temporada en el título */\n.season-tag {\n    display: inline-block;\n    background: #fef3c7;\n    color: #92400e;\n    font-size: .72rem;\n    font-weight: 700;\n    padding: .15rem .55rem;\n    border-radius: 99px;\n    margin-left: .6rem;\n    vertical-align: middle;\n}\n\n.no-phase-matches {\n    text-align: center;\n    color: #999;\n    padding: 1.5rem 0;\n    font-size: .95rem;\n}\n\n.history-card-wrapper {\n    margin-bottom: .6rem;\n    /* position: relative ya está declarado en el bloque del botón */\n}\n\n/* Botón asignar fase (solo capitanas) */\n.btn-assign-phase {\n    background: none;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    color: #6b7280;\n    cursor: pointer;\n    padding: .3rem .5rem;\n    font-size: .85rem;\n    transition: all .2s;\n    margin-left: auto;\n    flex-shrink: 0;\n}\n\n.btn-assign-phase:hover {\n    background: #fff7ed;\n    border-color: #f5a623;\n    color: #f5a623;\n}\n\n/* Panel de asignación inline */\n.assign-panel {\n    background: #f9fafb;\n    border: 1px solid #e5e7eb;\n    border-radius: 0 0 10px 10px;\n    padding: .75rem 1rem;\n    display: flex;\n    flex-wrap: wrap;\n    gap: .5rem;\n    align-items: center;\n}\n\n.assign-select {\n    border: 1.5px solid #d1d5db;\n    border-radius: 8px;\n    padding: .35rem .65rem;\n    font-size: .9rem;\n    outline: none;\n    flex: 1;\n    min-width: 130px;\n}\n\n.assign-select:focus { border-color: #1a1a2e; outline: none; }\n\n.assign-actions {\n    display: flex;\n    gap: .5rem;\n}\n\n.btn-save-assign {\n    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\n    color: #fff;\n    border: none;\n    border-radius: 7px;\n    padding: .4rem .9rem;\n    font-size: .85rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: .3rem;\n    transition: opacity .15s;\n}\n\n.btn-save-assign:hover { opacity: .85; }\n\n.btn-cancel-assign {\n    background: none;\n    border: 1px solid #d1d5db;\n    border-radius: 7px;\n    padding: .4rem .9rem;\n    font-size: .85rem;\n    cursor: pointer;\n    color: #6b7280;\n}\n\n.btn-cancel-assign:hover { background: #f3f4f6; }\n\n/* ── Phase points badge ─────────────────────────────────── */\n\n.phase-pts-badge {\n    font-size: .72rem;\n    font-weight: 700;\n    padding: .15rem .55rem;\n    border-radius: 99px;\n    margin-left: .5rem;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n/* ── Standings block ─────────────────────────────────────── */\n\n.standings-block {\n    margin-top: 14px;\n    margin-bottom: 16px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 14px 16px;\n}\n\n.standings-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 12px;\n}\n\n.standings-title {\n    font-size: .88rem;\n    font-weight: 700;\n    color: #334155;\n    display: flex;\n    align-items: center;\n    gap: .4rem;\n}\n\n.standings-title i {\n    color: #94a3b8;\n}\n\n.btn-add-standing {\n    background: none;\n    border: 1px solid #d1d5db;\n    border-radius: 7px;\n    color: #6b7280;\n    font-size: .78rem;\n    cursor: pointer;\n    padding: .3rem .65rem;\n    display: flex;\n    align-items: center;\n    gap: .3rem;\n    transition: all .18s;\n}\n\n.btn-add-standing:hover {\n    background: #eff6ff;\n    border-color: #3b82f6;\n    color: #3b82f6;\n}\n\n.standings-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: .85rem;\n    margin-bottom: 0;\n}\n\n.standings-table thead tr {\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.standings-table th {\n    padding: .3rem .5rem;\n    text-align: left;\n    font-size: .7rem;\n    font-weight: 700;\n    color: #94a3b8;\n    text-transform: uppercase;\n    letter-spacing: .5px;\n}\n\n.standings-table td {\n    padding: .45rem .5rem;\n    border-bottom: 1px solid #f1f5f9;\n    vertical-align: middle;\n}\n\n.standings-table tr:last-child td { border-bottom: none; }\n\n.standing-pos {\n    width: 28px;\n    font-weight: 700;\n    color: #94a3b8;\n    font-size: .8rem;\n}\n\n.standing-name {\n    font-weight: 600;\n    color: #1e293b;\n}\n\n.standing-pts {\n    font-weight: 700;\n    color: #0f172a;\n    text-align: center;\n    width: 40px;\n}\n\n.standing-actions {\n    text-align: right;\n    white-space: nowrap;\n    width: 60px;\n}\n\n.btn-standing-edit,\n.btn-standing-del {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: .2rem .35rem;\n    font-size: .78rem;\n    border-radius: 5px;\n    transition: background .15s, color .15s;\n}\n\n.btn-standing-edit { color: #94a3b8; }\n.btn-standing-edit:hover { background: #eff6ff; color: #3b82f6; }\n\n.btn-standing-del { color: #94a3b8; }\n.btn-standing-del:hover { background: #fee2e2; color: #dc2626; }\n\n/* ── Standing row — our team highlight ─────────────────── */\n\n.standing-row--ours {\n    background: #f0fdf4;\n}\n\n.standing-row--ours .standing-name {\n    color: #15803d;\n    font-weight: 700;\n}\n\n.standing-our-icon {\n    color: #16a34a;\n    font-size: .7rem;\n    margin-right: .35rem;\n    vertical-align: middle;\n}\n\n/* ── Inline pts edit input ──────────────────────────────── */\n\n.standing-pts-input {\n    width: 52px;\n    border: 1.5px solid #3b82f6;\n    border-radius: 6px;\n    padding: .2rem .35rem;\n    font-size: .88rem;\n    font-weight: 700;\n    text-align: center;\n    outline: none;\n}\n\n.standing-pts-input:focus { border-color: #1e293b; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
